import { Rectangle, Spin } from "./PlaceholderLoading";

export const Placeholder = Object.assign(Rectangle, { Rectangle, Spin });
